import { create } from 'zustand';

export const useEventsCache = create((set) => ({
  monthsCache: {},
  yearsCache: {},
  setMonthsCache: (deviceId, data) => set((state) => ({ monthsCache: { ...state.monthsCache, [deviceId]: data } })),
  setYearsCache: (deviceId, data) => set((state) => ({ yearsCache: { ...state.yearsCache, [deviceId]: data } })),
}));
